import Buttons from "./Buttons";
import Fields from "./Fields";
import Labels from "./Labels";
import Validations from "./Validations";

const DocumentsLang = {
  Buttons,
  Fields,
  Labels,
  Validations,
};

export default DocumentsLang;
